import React from "react";
import "./Day.css";
import Itembtn from "./Itembtn";

function Day({ clock, data }) {
  return (
    <div className="ground">
      {clock}
      {data.constructor === Array
        ? data.map((text) => {
            if (text[1] === clock) return <Itembtn text={text[0]}></Itembtn>;
          })
        : null}
    </div>
  );
}

export default Day;
